import { useTranslation } from "next-i18next";
import { useCallback, useEffect, useState } from "react";

import { Icon } from "@/components/elements/Icon";
import { useCart } from "@/hooks/useCart";
import useGlobalState from "@/hooks/useGlobalState";
import { getItemCount } from "@/utils/cart";

import header from "../header.module.css";

export const CartButton = () => {
  const { cartIsOpen, toggleCartIsOpen } = useGlobalState();
  const { t } = useTranslation("header");
  const { cart } = useCart();
  const [displayValue, setDisplayValue] = useState("");
  const totalProducts = getItemCount(cart.products);

  useEffect(() => {
    const value = totalProducts > 0 ? totalProducts : "";
    setDisplayValue(value as string);
  }, [totalProducts]);

  return (
    <button
      className={header.cart_button}
      onClick={useCallback(() => toggleCartIsOpen(), [])}
      aria-label={cartIsOpen ? t("cart.close") : t("cart.open")}
    >
      <Icon type="basket" size="sm" label={t("basket")} />

      {displayValue ? <span>{displayValue}</span> : null}
    </button>
  );
};
